import type {Severity} from 'src/internal/errors/sentry/types';
import type {ErrorScope} from 'src/internal/errors/types';
import type ReportsServer from 'src/internal/errors/utils/ReportsServer';
import type {ObservabilityConfig} from 'src/types';

const reporters = new Map<string, Promise<ReportsServer>>();

export async function initReports(id: string, config: ObservabilityConfig) {
  if (reporters.has(id)) {
    return;
  }

  const ReportsServerPromise = import(
    'src/internal/errors/utils/ReportsServer'
  );

  reporters.set(
    id,
    ReportsServerPromise.then(
      ({default: ReportsServer}) => new ReportsServer(config),
    ),
  );
}

export async function report(
  method: Exclude<Severity, 'info'>,
  id: string,
  error: any,
  scope?: ErrorScope,
) {
  const server = await reporters.get(id);

  server?.[method](error, scope);
}
